import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './IntraOne.frontend.types'

@Injectable({ providedIn: 'root' })
export class IntraOne_receive_data_0550Service {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { target_warehouse_name: string, target_location_name: string }): Promise<{ reason?: string[], log?: string[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.target_warehouse_name)) {
      $missingRequiredInParams.push('\'target_warehouse_name\'');
    }
    if (isNil($inParams.target_location_name)) {
      $missingRequiredInParams.push('\'target_location_name\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/IntraOne/functions/receive_data_0550`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

